import React from 'react';
import { LinearProgress, Backdrop } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import palette from '../../theme/palette'

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.8)'
    },
    image: {
        marginBottom: "10px"
    }
}));

const BorderLinearProgress = withStyles({
    root: {
        height: 10,
        width: "200px",
        margin: "auto",
        borderRadius: 20,
        border: "1px solid white",
        paddingTop: "10px",
        backgroundColor: palette.primary.light
    },
    bar: {
        borderRadius: 20,
        backgroundColor: palette.primary.main
    },
})(LinearProgress);

const Apploader = props => {
    const { loading } = props;
    const classes = useStyles();
    return (
        <Backdrop className={classes.backdrop} open={loading}>
            <div>
                <img className={classes.image} alt="Logo" src={ process.env.PUBLIC_URL + "/images/logos/logo-small-white.png" } />
                <BorderLinearProgress
                    variant="indeterminate"
                    color="primary"
                />
            </div>
        </Backdrop>
    );
};

export default Apploader;
